module.exports = __webpack_public_path__ + "img/product-preview-39.1cce552.png";